import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SocialRail from "./SocialRail";
import WhatsAppFloat from "./WhatsAppFloat";
import SignupPopup from "./SignupPopup";
import { Toaster } from "sonner";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-white text-neutral-950">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <SocialRail />
      <WhatsAppFloat />
      <SignupPopup />
      <Toaster position="top-center" richColors />
    </div>
  );
}
